import React from 'react';
import AppContext from '../../app-context';

export default class PoweredBy extends React.Component {
  static contextType = AppContext;

    render() {
        // Note: please do not wrap "Powered by Ghost" in the translation function, as we don't
        // want it to be translated

        return null;

    }
}
